import Vuex from 'vuex'
import Vue from 'vue'
import createPersistedState from 'vuex-persistedstate'

import Dashboard from '@/store/dashboard/Dashboard.js'

import classModule from './learning/class'
import classDetail from './learning/classDetail'
import timeTable from './learning/timeTable'
import draftTimeTable from './learning/draftTimeTable'
import category from './other/category'
import email from './notify/email'
import search from './view/search.js'

// bus
import bus from './bus/bus.js'
import busDetail from './bus/busDetail.js'
import BusStudents from './bus/BusStudents.js'
import BusStudentAttendance from './bus/BusStudentAttendance.js'
import BusStudentAttendanceDetail from '@/store/bus/BusStudentAttendanceDetail.js'
import BusCheckin from '@/store/bus/BusCheckin/BusCheckin.js'
import busStudentTracking from '@/store/bus/busStudentTracking.js'

/**
 * SALE
/**
 * CLASS
 */
import semester from './course/semester'
import slot from './learning/slot'

import log from './other/log'
import event from './learning/event'
import mark from './learning/mark'
/**
 * MARK
 */
import Mark from './mark/Mark'
import MarkInput from './mark/MarkInput'
import StudentMark from './student/StudentMark'
import ClassMarkInput from './mark/ClassMarkInput.js'
import ClassMark from './mark/ClassMark.js'
/**
 * STUDENT
 */
import { axiosPlugin } from '@/plugins/axios'
import students from './user/students'
import studentDashboard from './dashboard/studentDashboard'
import student from './user/student'
import studentImporter from './importer/studentImporter.js'
import attendance from './student/attendance'
import { setWith } from 'lodash'
/**
 */
import departmentDashboard from '@/store/dashboard/departmentDashboard.js'
import role from './app/role'
import staff from './user/staff'
import teacher from './user/teacher'
import ownClassTeacher from './teacher/ownClassTeacher'
import teaching from './teacher/teaching'
import teachers from './user/teachers'
import teacherDashboard from './dashboard/teacherDashboard'

import division from './division/division'
import grade from './grade/grade'
import subjects from './subject/subjects'
import violation from './violation/violation'
/**
 * APPLICATIONS
 */
import app from './app/app'
import policies from './policies/policies'
import noti from './notify/noti'
import { createStore } from 'vuex-extensions'
import constant from './other/constant'
import upload from './other/upload'
import rest from './other/rest'
import auth from './app/auth'
import view from './view'
import user from './app/user'
import factor from './factor/factor'

import postCreate from './post/post-create'
import PostCreateAuto from './post/PostCreateAuto'

import SubjectGroup from './subjectGroup/SubjectGroup'
import ContactBook from './contactBook/ContactBook'
import SmsHistory from './smsHistory/SmsHistory'
import AppHistory from './appHistory/AppHistory'
import StudentPostHistory from './contactBook/StudentPostHistory'
import AttendanceDetail from './student/AttendanceDetail'
import AcademicLevel from './academicLevel/AcademicLevel'
import Diligence from './student/Diligence'
import OnlineStudy from '@/store/onlineStudy/OnlineStudy.js'
import Feedback from '@/store/feedback/Feedback.js'
import TeacherFeedback from '@/store/feedback/TeacherFeedback.js'
import DocumentTypes from '@/store/document/DocumentTypes.js'
import Documents from '@/store/document/Documents.js'
import TeachingReport from '@/store/teachingReport/TeachingReport.js'

import ClassNoteDetail from '@/store/teacher/ClassNoteDetail.js'
import ClassNotes from '@/store/teacher/ClassNotes.js'

import Integration from '@/store/integrations/Integration.js'

// meal
import Dishes from '@/store/dish/Dishes.js'
import FoodMenu from '@/store/foodMenu/FoodMenu.js'
import StudentMenuRegister from '@/store/studentMenuRegister/StudentMenuRegister.js'
import MealReport from '@/store/mealReport/MealReport.js'

// Exams
import exam from './exam/exam.js'
import subjectExam from './subjectExam/subjectExam.js'
import subjectExamGroup from './exam/subjectExamGroup.js'
import room from './exam/room.js'
import studentExam from './exam/studentExam.js'
import examRoom from './exam/examRoom.js'
import indexing from './exam/indexing.js'
import examMark from './exam/examMark.js'
import roomSubject from './exam/roomSubject.js'
import teacherExam from './exam/teacherExam.js'
import monitor from './exam/monitor.js'
import gradeReview from './exam/gradeReview.js'

// tuition
import tuitonFeeHeadFee from '@/store/tuitionFee/headFee.js'
import tuitionFeeGroup from '@/store/tuitionFee/group'
import tuitionFeeGroupStudent from '@/store/tuitionFee/groupStudent'
import tuitionFeeGroupHeadFee from '@/store/tuitionFee/groupHeadFee'
import tuitonFeePrice from '@/store/tuitionFee/price'
import tuitionFeePriceStudent from '@/store/tuitionFee/priceStudent'
import tuitionFeePeriod from '@/store/tuitionFee/period'
import bankAccount from '@/store/tuitionFee/bankAccount'
import tuitionFeeReport from '@/store/tuitionFee/report'
import tuitionFeeCollection from '@/store/tuitionFee/collection.js'
import taskProgress from '@/store/taskProgress/taskProgess'

// salary
import salaryCollection from '@/store/salary/collection'
import salaryGroup from '@/store/salary/group'
import salaryGroupHead from '@/store/salary/groupHead'
import salaryGroupTeacher from '@/store/salary/groupTeacher'
import salaryHead from '@/store/salary/head.js'
import salaryPeriod from '@/store/salary/period.js'
import salaryPrice from '@/store/salary/price.js'
import salaryPriceTeacher from '@/store/salary/priceTeacher.js'
import salaryReport from '@/store/salary/report.js'
// teacherDoc
import teacherDoc from './teacher-doc/teacherDoc'
// Task manager - Quản lý tác vụ, công việc
import task from '@/store/task/task'
// chưa biết đặt tên là gì
import absentRequest from '@/store/absent-request/AbsentRequest'

// student credit
import studentCredit from '@/store/studentCredit/index.js'
import studentCreditUsage from './studentCreditUsage/index.js'

import busInformation from './bus/busInformation.js'
import busRegister from './bus/busRegister.js'

Vue.use(Vuex)

export default createStore(Vuex.Store, {
  plugins: [
    createPersistedState({
      key: 'lms',
      paths: [
        'auth.user',
        'auth.policies',
        'auth.role',
        'auth.isAuthenticated',
        'auth.jwt',
        'app.currentSchoolYear',
        'app.currentSemester'
      ]
    }),
    axiosPlugin
  ],
  modules: {
    busDetail,
    bus,
    BusStudents,
    BusStudentAttendance,
    BusStudentAttendanceDetail,
    BusCheckin,
    Dashboard,
    rest,
    attendance,
    auth,
    view,
    user,
    staff,
    teacher,
    teachers,
    teaching,
    ownClassTeacher,
    class: classModule,
    semester,
    category,
    email,
    constant,
    slot,
    event,
    upload,
    noti,
    app,
    policies,
    role,
    log,
    mark,
    classDetail,
    timeTable,
    draftTimeTable,
    teacherDashboard,
    departmentDashboard,
    students,
    student,
    studentDashboard,
    studentImporter,
    division,
    grade,
    factor,
    subjects,
    violation,
    search,
    postCreate,
    PostCreateAuto,
    MarkInput,
    Mark,
    StudentMark,
    SubjectGroup,
    ContactBook,
    SmsHistory,
    AppHistory,
    StudentPostHistory,
    AttendanceDetail,
    AcademicLevel,
    Diligence,
    ClassMarkInput,
    ClassMark,
    OnlineStudy,
    Feedback,
    TeacherFeedback,
    DocumentTypes,
    Documents,
    ClassNoteDetail,
    ClassNotes,
    TeachingReport,
    Dishes,
    FoodMenu,
    StudentMenuRegister,
    MealReport,
    Integration,
    tuitonFeeHeadFee,
    tuitionFeeGroup,
    tuitionFeeGroupStudent,
    tuitionFeeGroupHeadFee,
    tuitonFeePrice,
    tuitionFeePriceStudent,
    tuitionFeePeriod,
    bankAccount,
    tuitionFeeReport,
    tuitionFeeCollection,
    taskProgress,
    task,
    absentRequest,
    // exam
    exam,
    subjectExam,
    subjectExamGroup,
    room,
    studentExam,
    examRoom,
    indexing,
    examMark,
    roomSubject,
    teacherExam,
    monitor,
    gradeReview,
    // salary
    salaryCollection,
    salaryGroup,
    salaryGroupHead,
    salaryGroupTeacher,
    salaryHead,
    salaryPeriod,
    salaryPrice,
    salaryPriceTeacher,
    salaryReport,
    teacherDoc,
    studentCredit,
    studentCreditUsage,
    busInformation,
    busStudentTracking,
    busRegister
  },
  mixins: {
    mutations: {
      changeState: function(state, changed) {
        Object.entries(changed).forEach(([name, value]) => {
          state[name] = value
        })
      },
      changeDeepState: function(state, changed) {
        Object.entries(changed).forEach(([firstChildName, diff]) => {
          const firstChildValue = { ...state[firstChildName] }
          Object.entries(diff).forEach(([path, diffValue]) => {
            setWith(firstChildValue, path, diffValue)
          })
          state[firstChildName] = firstChildValue
        })
      }
    }
  }
})
